import Modal from '../../common/Modal/Modal';
import GoodsIn from '../../api/controllers/GoodsIn/GoodsIn';
import GoodsOut from '../../api/controllers/GoodsOut/GoodsOut';
import Hub from '../../api/controllers/Hub/Hub';
import Packages from '../../api/controllers/Packages/Packages';
import './InProgressJob.scss';
import { useEffect, useState } from 'react';
import MovementDetails from '../../common/MovementDetails/MovementDetails';
import MovementNotesPhotos from '../../common/MovementNotesPhotos/MovementNotesPhotos';
import CancelModal from './subComponents/CancelModal/CancelModal';
import PackageList from '../../common/PackageList/PackageList';
import PropTypes from 'prop-types';
import DeleteUnit from './subComponents/DeleteUnit/DeleteUnit';
import UnitsUnloadedModal from './subComponents/UnitsUnloadedModal/UnitsUnloadedModal';
import ConfirmModal from './subComponents/ConfirmModal/ConfirmModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import AssociatedPackageList from '../PendingMovement/subComponents/AssociatedPackageList/AssociatedPackageList';
import LoadAllModal from './subComponents/LoadAllModal/LoadAllModal';
import ResetModal from './subComponents/ResetModal/ResetModal';
import Error from '../../common/Error/Error';
import Job from '../../api/controllers/Job/Job';
import Button from '../../common/Button/Button';

// InProgressJob Screen Component
const InProgressJob = ({
  notExpected,
  fromPending,
  setDisplayAssignment,
  movement,
  getMovement,
  setError,
  setLoading,
  qrResponse,
  assignment,
  category,
  movementType,
  allAssignedPackages,
}) => {
  const [bays, setBays] = useState();
  const [racks, setRacks] = useState();
  const [baysAndRacks, setBaysAndRacks] = useState();
  const [damagePhoto, setDamagePhoto] = useState(false);
  const [multipleMovementIndicator, setMultipleMovementIndicator] = useState();
  const [packages, setPackages] = useState();
  const [job, setJob] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const expQuantity = assignment?.quantity || 0;
  const actQuantityPackages = packages?.length;
  const actQuantityItems = packages?.map(pkg => pkg?.quantity).reduce((a, b) => a + b, 0);
  const actType =
    packages && packages[0]?.packageType?.shortName
      ? packages?.every(pkg => pkg?.packageType?.shortName == packages[0]?.packageType?.shortName)
        ? packages[0]?.packageType?.shortName
        : 'pkg'
      : 'pkg';
  const expWeight = assignment?.grossWeightKg || 0;
  const actWeight = packages?.map(pkg => pkg?.grossWeightKg).reduce((a, b) => a + b, 0);
  const expVolume = Number(assignment?.cubicMetres)?.toFixed(2);
  const actVolume = packages
    ?.map(pkg => Number(pkg?.cubicMetres))
    .reduce((a, b) => a + b, 0)
    .toFixed(2);

  const addUnit = () => {
    setLoading(true);
    GoodsIn.updatePackageCount(category, movement.id, job?.id, packages?.length + 1)
      .then(() => {
        setLoading(false);
        getPackages();
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const [modalOpen, setModalOpen] = useState();

  const getModalTitle = () => {
    switch (modalOpen) {
      case 'finish':
        return 'Confirm';
      case 'update_package_number':
        return 'Number of units unloaded';
      default:
        return null;
    }
  };

  const getModalType = () => {
    switch (modalOpen) {
      case 'unload_all':
        return (
          <LoadAllModal
            setModalOpen={setModalOpen}
            category={category}
            movement={movement}
            assignment={assignment}
            movementType={movementType}
            refreshPackages={() => {
              getPackages();
            }}
          />
        );
      case 'reset':
        return (
          <ResetModal
            setModalOpen={setModalOpen}
            category={category}
            movement={movement}
            refreshPackages={() => {
              getPackages();
            }}
            packages={packages}
            movementType={movementType}
            assignment={assignment}
          />
        );
      case 'finish':
        return (
          <ConfirmModal
            category={category}
            id={movement.id}
            movementType={movementType}
            setModalOpen={setModalOpen}
            refreshMovement={getMovement}
            damaged={packages?.some(pkg => pkg?.damaged) || damagePhoto}
          />
        );
      case 'cancel':
        return (
          <CancelModal
            category={category}
            id={movement.id}
            movementType={movementType}
            setModalOpen={setModalOpen}
          />
        );
      case 'delete_unit':
        return (
          <DeleteUnit
            category={category}
            movementId={movement?.id}
            jobId={job?.id}
            refreshPackages={getPackages}
            setModalOpen={setModalOpen}
            numOfPackages={packages?.length - 1}
          />
        );
      case 'update_package_number':
        return (
          <UnitsUnloadedModal
            category={category}
            assignment={assignment}
            job={job}
            movementId={movement?.id}
            movementType={movementType}
            setModalOpen={setModalOpen}
            refreshMovement={getPackages}
            currentTotal={packages ? packages?.length : 0}
          />
        );
    }
  };

  const getJob = () => {
    setLoading(true);
    Job.show(assignment?.job?.id)
      .then(response => {
        setJob(response);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getPackages = () => {
    setLoading(true);
    const params =
      movementType == 'collections' || movementType == 'imports'
        ? { goodsInType: movement?.modelName, goodsInId: movement?.id, jobId: job?.id }
        : { goodsOutType: movement?.modelName, goodsOutId: movement?.id, jobId: job?.id };
    Packages.all(params)
      .then(response => {
        setPackages(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getBays = async () => {
    setLoading(true);
    Hub.show(hubId)
      .then(response => {
        setBaysAndRacks(response.bays);
        setBays(response.bays.filter(bay => bay.bayType != 'racking'));
        const racks = response.bays.filter(bay => bay.bayType == 'racking');
        setRacks(Object.groupBy(racks, rack => rack.bayNumber));
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getMultipleMovementIndicator = async () => {
    setLoading(true);
    const params = { category: category, jobId: job?.id };
    if (movementType == 'collections' || movementType == 'imports') {
      GoodsIn.all(params)
        .then(response => {
          setMultipleMovementIndicator(response.items.length);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    } else {
      GoodsOut.all(params)
        .then(response => {
          setMultipleMovementIndicator(response.items.length);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
  };

  const [relatedExports, setRelatedExports] = useState();

  const getRelatedExports = () => {
    setLoading(true);
    const params = { category: 'international', jobId: movement?.assignments[0]?.job?.id };
    GoodsOut.all(params)
      .then(response => {
        setRelatedExports(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    if (fromPending && movementType == 'collections') {
      setModalOpen('update_package_number');
    }
    getBays();
    getJob();
    if (movementType == 'collections') {
      getRelatedExports();
    }
  }, []);

  useEffect(() => {
    if (job) {
      getMultipleMovementIndicator();
      getPackages();
    }
  }, [job]);

  useEffect(() => {
    if (allAssignedPackages) {
      getPackages();
    }
  }, [allAssignedPackages]);

  useEffect(() => {
    if (job && packages && bays && multipleMovementIndicator) {
      setLoading(false);
    }
  }, [job, packages, bays, multipleMovementIndicator]);

  useEffect(() => {
    document.body.style.overflow = modalOpen ? 'hidden' : 'unset';
  }, [modalOpen]);

  return (
    <div data-testid="in_progress_container">
      {notExpected && (
        <Error
          errorMessages={`This job was not expected to be ${
            movementType == 'imports' ? 'unl' : 'l'
          }oaded on this ${movementType.substring(0, movementType.length - 1)}!`}
          type={'error'}
          errorTitle="Warning"
        />
      )}
      {relatedExports?.map(relatedExport => {
        if (relatedExport.expectedBayId) {
          return (
            <Error
              key={relatedExport.reference}
              errorMessages={`Export trailer ${
                relatedExport?.reference || '(No Groupage)'
              } expects these packages to be loaded from ${`${
                baysAndRacks?.find(b => b.id == relatedExport?.expectedBayId)?.bayType[0]
              }${
                baysAndRacks?.find(b => b.id == relatedExport?.expectedBayId)?.bayNumber
              }`.toUpperCase()}`}
              type={'expected_bay'}
            />
          );
        }
      })}
      <MovementDetails movement={movement} category={'domestic'} job={job} />
      <div className="expected_actual_values">
        <div className="packages_ref">{'Reference: '}</div>
        <div className="value grey">{movement?.reference || 'Not provided'}</div>
        {multipleMovementIndicator > 1 && (
          <div className="value multi_movement">
            <FontAwesomeIcon icon={faInfoCircle} /> This job has {multipleMovementIndicator}{' '}
            {movementType}
          </div>
        )}
        <div className="packages_expected_quantity">{'Expected Quantity: '}</div>
        <div className="value">
          {expQuantity} {job?.packageType?.shortName || 'pkg'}
        </div>
        <div className="packages_actual_quantity">{'Actual Quantity: '}</div>
        <div
          className={`value ${
            actQuantityItems != actQuantityPackages
              ? 'item_mismatch'
              : actQuantityPackages == expQuantity
              ? 'match'
              : 'mismatch'
          }`}
        >
          {actQuantityPackages} {actType}{' '}
          {actQuantityItems != actQuantityPackages && `(${actQuantityItems} items)`}
        </div>
        <div className="packages_expected_weight">{'Expected Weight: '}</div>
        <div className="value">{expWeight} kg</div>
        <div className="packages_actual_weight">{'Actual Weight: '}</div>
        <div className={`value ${actWeight == expWeight ? 'match' : 'mismatch'}`}>
          {actWeight} kg
        </div>
        <div className="packages_expected_volume">{'Expected Volume: '}</div>
        <div className="value">{expVolume} m³</div>
        <div className="packages_actual_volume">{'Actual Volume: '}</div>
        <div className={`value ${actVolume == expVolume ? 'match' : 'mismatch'}`}>
          {actVolume} m³
        </div>
      </div>
      {movementType == 'imports' && (
        <div className="in_progress_movement_buttons bottom_border with_overview">
          <Button
            buttonType={'grey'}
            className="in_progress_movement_button grey overview"
            onClick={() => setDisplayAssignment(false)}
            label={
              <div className="overview_back">
                <FontAwesomeIcon icon={faArrowLeft} />
                Overview
              </div>
            }
          />
          <Button
            buttonType={'light_blue'}
            className="in_progress_movement_button light_blue load_all"
            onClick={() => setModalOpen('unload_all')}
            label="Unload all"
          />
          <Button
            buttonType={'orange'}
            className={`in_progress_movement_button orange reset_loading`}
            onClick={() => setModalOpen('reset')}
            label="Reset"
          />
        </div>
      )}
      {(movementType == 'collections' || movementType == 'imports') && packages && (
        <PackageList
          job={job}
          packages={packages}
          refetchPackages={getPackages}
          bays={bays}
          racks={racks}
          specialActionType={'remove_unit'}
          specialAction={() => setModalOpen('delete_unit')}
          numGhostPackages={expQuantity > packages.length ? expQuantity - packages?.length : 0}
          ghostAction={addUnit}
          massSpecial={() => setModalOpen('update_package_number')}
        />
      )}
      {(movementType == 'deliveries' || movementType == 'exports') && packages && (
        <AssociatedPackageList
          job={job}
          hubId={hubId}
          bays={bays}
          racks={racks}
          setError={setError}
          setLoading={setLoading}
          assignedPackages={packages}
          refreshPackages={getPackages}
          movement={movement}
          movementType={movementType}
          category={category}
          qrResponse={qrResponse}
          setDisplayAssignment={setDisplayAssignment}
        />
      )}
      {(movementType == 'collections' || movementType == 'deliveries') && (
        <>
          <MovementNotesPhotos
            setError={setError}
            movement={movement}
            movementType={movementType}
            setDamaged={setDamagePhoto}
          />
          <div className="in_progress_movement_buttons">
            <Button
              buttonType="red"
              className="in_progress_movement_button red cancel"
              onClick={() => setModalOpen('cancel')}
              label="Cancel"
            />
            <Button
              buttonType="green"
              className="in_progress_movement_button green finish_unloading"
              onClick={() => setModalOpen('finish')}
              disabled={packages?.length == 0}
              label={`Finish ${
                movementType == 'collections' || movementType == 'imports' ? 'Unl' : 'L'
              }oading`}
            />
          </div>
        </>
      )}
      {modalOpen && (
        <Modal title={getModalTitle()} content={getModalType()} setModalOpen={setModalOpen} />
      )}
    </div>
  );
};

InProgressJob.propTypes = {
  notExpected: PropTypes.bool,
  fromPending: PropTypes.bool,
  setDisplayAssignment: PropTypes.func,
  movement: PropTypes.object,
  qrResponse: PropTypes.object,
  getMovement: PropTypes.func,
  setError: PropTypes.func,
  setLoading: PropTypes.func,
  assignment: PropTypes.object,
  category: PropTypes.string,
  movementType: PropTypes.string,
  allAssignedPackages: PropTypes.array,
};

export default InProgressJob;
